<template>
    <div class="fixed-aside">
        <div v-show="showBackTop" class="back-top" @click="scrollToTop"></div>
        <div v-show="isHome" class="aside-item aside-item-toReport pointer" @click="toReport">
            <div class="aside-item-container aside-item-container-toReport">
                <div class="aside-item-wrapper">
                    <div class="toReport-entrance">
                        <img src="../assets/img/toReport.png" alt="">
                    </div>
                    <div class="toReport-entrance-in">
                        <img src="../assets/img/toReport_in.png" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div v-show="isHome" class="aside-item pointer" @click="toBaoliao">
            <div class="aside-item-container">
                <div class="aside-item-wrapper">
                    <div class="line-submit"></div>
                    <div class="line-submit-in"></div>
                </div>
            </div>
        </div>
        <div v-show="isHome" class="aside-item pointer" @click="toWeibo">
            <div class="aside-item-container">
                <div class="aside-item-wrapper">
                    <div class="weibo"></div>
                    <div class="weibo-in"></div>
                </div>
            </div>
        </div>
        <div v-show="isHome" class="aside-item pointer with-download-code">
            <div class="aside-item-container">
                <div class="aside-item-wrapper">
                    <div class="weixin"></div>
                    <div class="weixin-in"></div>
                </div>
            </div>
            <div class="code-img weixin-code"></div>
        </div>
        <!-- <div v-show="isHome" class="weibo with-download-code" @click="toWeibo">
            <div></div>
        </div>
        <div v-show="isHome" class="weixin with-download-code pointer">
            <div></div>
        </div> -->
    </div>
</template>
<script>
import { mapMutations } from 'vuex';
export default {
    name: "BackTop",
    data() {
        return {
            showBackTop: false,
            isHome: false
        }
    },
    watch: {
        $route (val) {
            if(val.path == '/') {
                this.isHome = true
            }
            else {
                this.isHome = false
            }
        },
    },
    mounted() {
        window.addEventListener('scroll', this.watchScroll)
    },
    destroyed() {
        window.removeEventListener('scroll', this.watchScroll)
    },
    methods: {
        ...mapMutations(['setShowPop']),
        watchScroll() {
            if(Math.ceil((document.body.scrollTop || document.documentElement.scrollTop)) >= (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight)) {
                this.showBackTop = true
            } else {
                this.showBackTop = false
            }
        },
        scrollToTop() {
            if(document.body.scrollTop) {
                document.body.scrollTop = 0
            } else if(document.documentElement.scrollTop) {
                document.documentElement.scrollTop = 0
            }
        },
        toWeibo() {
            window.open('https://weibo.com/scpiyao');
        },
        toBaoliao() {
            // var r = window.confirm('您即将进入辟谣联盟成员“封面新闻”官网提交辟谣线索，我们将尽快处理。')
            // if(r) {
            //     window.open('http://www.thecover.cn/cloudHelp')
            // }
            // let flag = localStorage.getItem('notShowPiyaoPop') || false;
            // if(flag) {
                window.open('https://www.scjb.gov.cn/reportInstructions/8');
            //     return;
            // }
            // this.setShowPop(true);
        },
        toReport() {
            window.open('https://www.scjb.gov.cn/reportInstructions/3');
        }
    },
}
</script>
<style lang="less" scoped>
.fixed-aside {
    width: 5.125rem;
    position: fixed;
    bottom: 6.25rem;
    left: 50%;
    margin-left: 32.0625rem;
    z-index: 999;
    div {
        height: 5.125rem;
        margin-bottom: 0.625rem;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        cursor: pointer;
        position: relative;
        // z-index: 1900;
        // border: 1px solid #AED9FF;
        // &:hover {
        //     border: 1px solid #006DF1;
        // }
    }
    .back-top {
        background-image: url('./../assets/img/new_backTop.png');
    }
    // .weibo {
    //     background-image: url('./../assets/img/weibo.png');
    // }
    // .weixin {
    //     background-image: url('./../assets/img/weixin.png');
    // }
    .aside-item {
        margin-bottom: 0.625rem;
        .aside-item-container {
            width: 5.125rem;
            height: 5.125rem;
            overflow: hidden;
            .aside-item-wrapper {
                transition: all .2s;
                white-space: nowrap;
                div {
                    display: inline-block;
                    width: 5.125rem;
                }
                .toReport-entrance {
                    background-image: url('./../assets/img/toReport_bg.png');
                    background-size: 100% 100%;
                    height: 100%;
                    text-align: center;
                    img {
                        width: 2.0625rem;
                        height: auto;
                        margin-top: .875rem;
                    }
                }
                .toReport-entrance-in {
                    background-image: url('./../assets/img/toReport_in_bg.png');
                    background-size: 100% 100%;
                    height: 100%;
                    text-align: center;
                    img {
                        width: 2.0625rem;
                        height: auto;
                        margin-top: .875rem;
                    }
                }
                .line-submit {
                    background-image: url('./../assets/img/lineSubmit.png');
                }
                .line-submit-in {
                    background-image: url('./../assets/img/lineSubmit_in.png');
                }
                .weibo {
                    background-image: url('./../assets/img/new_weibo.png');
                }
                .weibo-in {
                    background-image: url('./../assets/img/new_weibo_in.png');
                }
                .weixin {
                    background-image: url('./../assets/img/new_weixin.png');
                }
                .weixin-in {
                    background-image: url('./../assets/img/new_weixin_in.png');
                }
            }
        }
        &:hover {
            .aside-item-container {
                .aside-item-wrapper {
                    transform: translateX(-5.125rem);
                }
            }
        }
    }
    .aside-item-toReport {
        height: 6.125rem;
        .aside-item-container-toReport {
            height: 100%;
            .aside-item-wrapper {
                height: 100%;
            }
        }
    }
    .with-download-code {
        position: relative;
    }
    .with-download-code .code-img {
        position: absolute;
        left: -11.875rem;
        top: -1px;
        width: 10.875rem;
        height: 10.875rem;
        background-position: center;
        background-size: 9.375rem 9.375rem;
        background-repeat: no-repeat;
        -webkit-transition: none;
        transition: none;
        -webkit-transform: scale(0);
        -ms-transform: scale(0);
        transform: scale(0);
        -webkit-transform-origin: right top;
        -ms-transform-origin: right top;
        transform-origin: right top;
    }
    .with-download-code:hover .code-img {
        -webkit-transform: scale(1);
        -ms-transform: scale(1);
        transform: scale(1);
        -webkit-transition: all .3s cubic-bezier(.31,.57,.68,1.36);
        transition: all .3s cubic-bezier(.31,.57,.68,1.36)
    }
    .weixin-code {
        background-image: url('./../assets/img/weixinQR.jpg');
    }
}
</style>